import { isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js'

/** Generic phone formatting */
export const formatPhone = (e164String) => {
  if (!e164String) return ''

  const phone = parsePhoneNumberFromString(e164String)
  return (
    !phone ? ''
    : phone.countryCallingCode === '1' ? phone.formatNational()
    : phone.formatInternational()
  )
}

// Outputs (XXX) XXX - XXXX
export const formatPhoneInput = (input: string): string => {
  // Remove all non-digit characters
  let digits = input.replace(/\D/g, '')

  // Prevent '1' as the first digit
  if (digits.startsWith('1') || digits.startsWith('0')) {
    digits = digits.slice(1)
  }

  // Limit to 10 digits
  digits = digits.slice(0, 10)

  if (digits.length === 0) {
    return ''
  }

  if (digits.length < 4) {
    return `(${digits}`
  }

  if (digits.length < 7) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  }

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)} - ${digits.slice(6)}`
}

export const filterNumbersAndSpaces = (value: string): string => value.replace(/[^\d\s]/g, '')

export const isValidUSPhoneNumber = (value?: string | null) =>
  value && typeof value === 'string' && value.startsWith('+1') && isValidPhoneNumber(value, 'US')
